import styled from '@emotion/styled';

const ArticleList = styled('div')(({ theme }) => ({
  marginBottom: theme.dimensions.pageGutter,
  marginTop: theme.dimensions.gutter,
  textAlign: 'center',
}));

export default ArticleList;
